var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS5P2Img11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_345",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.38623,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29529 20.6551L2.10596 11.6496L13.3252 5.18677H15.8985C16.2367 6.42046 16.7163 7.4958 17.3374 8.41277C17.9585 9.32974 19.0127 9.78823 20.5 9.78823C21.9873 9.78823 23.0415 9.32974 23.6626 8.41277C24.2837 7.4958 24.7633 6.42046 25.1015 5.18677H27.6748L38.8524 11.6913L33.7047 20.6551L30.6993 19.0165V26.1895L28.0643 28.4911C27.9013 28.6197 27.7271 28.734 27.5417 28.834C27.3563 28.9339 27.1781 29.005 27.0072 29.0473V12.742L32.3152 15.6669L33.8225 13.0292L27.4375 9.32085C26.7908 10.5956 25.8382 11.6075 24.5797 12.3566C23.3213 13.1057 21.9614 13.4803 20.5 13.4803C19.0386 13.4803 17.6887 13.1041 16.4502 12.3516C15.2117 11.5992 14.2657 10.579 13.6123 9.29093L7.13587 13.0292L8.68479 15.6669L13.9927 12.742V22.6868C13.3563 22.729 12.7271 22.8177 12.1051 22.9526C11.4831 23.0876 10.8816 23.2795 10.3007 23.5283V19.0165L7.29529 20.6551ZM8.23008 33.1161L5.83425 30.3054L9.58875 27.1026C10.2476 26.5271 10.9983 26.0918 11.841 25.7969C12.6837 25.5019 13.5562 25.3544 14.4583 25.3544C15.3605 25.3544 16.226 25.5019 17.0548 25.7969C17.8836 26.0918 18.6274 26.5271 19.2862 27.1026L24.1196 31.2276C24.4396 31.492 24.8172 31.6973 25.2522 31.8435C25.6873 31.9896 26.131 32.0627 26.5833 32.0627C27.0567 32.0627 27.4988 31.9949 27.9094 31.8594C28.3201 31.7238 28.6854 31.5132 29.0054 31.2276L32.7699 27.983L35.1657 30.8453L31.4112 34.0482C30.7524 34.6237 30.0086 35.052 29.1798 35.3331C28.351 35.6142 27.4855 35.7547 26.5833 35.7547C25.6812 35.7547 24.8087 35.6142 23.966 35.3331C23.1233 35.052 22.3726 34.6237 21.7137 34.0482L16.8804 29.9232C16.5604 29.6587 16.1951 29.4534 15.7844 29.3073C15.3738 29.1611 14.9317 29.0881 14.4583 29.0881C14.006 29.0881 13.5623 29.1611 13.1272 29.3073C12.6922 29.4534 12.3146 29.6587 11.9946 29.9232L8.23008 33.1161Z",
    fill: "#B84031"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS5P2Img11);
export default __webpack_public_path__ + "static/media/HomeS5P2Img11.58d8788ccfa3233b0974ba91528bb432.svg";
export { ForwardRef as ReactComponent };